// extracted by mini-css-extract-plugin
module.exports = {"templatePicker":"TemplatePicker_templatePicker__BZSnl","list":"TemplatePicker_list__2Czoh"};